import {EntityApiService, ApiClientService} from '@dofleini/security';
import moment from 'moment/moment';
import {FilterFactory, RangeFilter} from '@dofleini/query-builder';

class AuditsApiService extends EntityApiService {

  constructor(path) {
    super();
    this.summaryParams = {};
    this.path = path;
  }

  getSummaryParams(params){
    return {filters: params?.filters, ...params, ...this.summaryParams };
  }

  transformDate = (date) => {
    if (date && date?.length) {
      return {
        from: moment(date[0]).toISOString(),
        to: moment(date[1]).toISOString(),
      };
    }
    return {};
  }

  // eslint-disable-next-line
  getSummaryParamsForStatistics(params){
    return {...this.getSummaryParams(params), ...this.summaryParams, date: this.transformDate(this.summaryParams?.date), filters: null};
  }

  setSummaryParams(params){
    this.summaryParams = params;
  }

  summarySearch = (params) => {
    return ApiClientService.post('/ms-statistics/api/audit-statistics/benchmark', this.getSummaryParamsForStatistics(params));
  }

  issueClientBenchmarkSearch = (params) => {
    return ApiClientService.post(this.getPath('/search-benchmark-from-issue-client'), this.getSummaryParams(params));
  }

  issuesByTypeSearch = (params) => {
    return ApiClientService.post('/ms-statistics/api/issue-statistics/by-type', this.getSummaryParamsForStatistics(params)).then((response) => {
      return Promise.resolve({ ...response, data: response?.data?.data });
    });
  }

  biolineaAverageScore = (params) => {
    return ApiClientService.post('/ms-statistics/api/audit-statistics/bio-score', this.getSummaryParamsForStatistics(params));
  }

  incidentsTopFive = (params) => {
    return ApiClientService.post('/ms-statistics/api/issue-statistics/top-five', this.getSummaryParamsForStatistics(params));
  }

  downloadStatisticsExcel = (params) => ApiClientService.post(this.getPath('/statistics-excel'), this.getSummaryParams(params), {responseType: 'arraybuffer'});
  downloadCategorizationPdf = async (params) => {
    const response = await ApiClientService.post(this.getPath('/categorization-pdf'), this.getSummaryParams(params));
    return response?.data;
  };
  getChartData = (params) => ApiClientService.post(this.getPath('/get-chart-data'), this.getSummaryParams(params));

  incidencesCounts = (params) => {
    return ApiClientService.post('/ms-statistics/api/issue-statistics/count-by-risk', this.getSummaryParamsForStatistics(params));
  }

  searchIssues = (params) => {
    const { date, filters } = this.getSummaryParams(params);

    const filtersNew = () => {
      const startOfMonth = moment(date?.[0]).startOf('month').format('YYYY-MM-DD hh:mm');
      const endOfMonth   = moment(date?.[1]).endOf('month').format('YYYY-MM-DD hh:mm');

      const dateRangeFilter = new RangeFilter({
        field: 'auditDate', type: 'RANGE',
        from: moment(startOfMonth)?.startOf('month').toISOString(),
        to: moment(endOfMonth)?.endOf('month').toISOString(),
        isDate: true,
      });

      return filters ? FilterFactory.add(filters, dateRangeFilter)?.toQuery() : dateRangeFilter?.toQuery();
    };
    return ApiClientService.post('/ms-core/api/issues/search-issues', this.getSummaryParams({...params, filters: filtersNew()}));
  }

}

export default new AuditsApiService('/ms-core/api/audits');
